import React, { useLayoutEffect, useState } from 'react';
import VREPlayer from 'videojs-react-enhanced';
import 'video.js/dist/video-js.css';
import './style.scss';
import Thumbprint from '../Thumbprint';
import {connect, useDispatch} from "react-redux";
import {setVideoPlayerId, setVideoPlayerIsPlaying} from "../../../redux/actions/videoPlayer";

const PVideo = ({
    thumb,
    video,
    autoplay = false,
    videoOptions = {},
    preload = "metadata",
    muted = false,
    isPlaying,
}) => {
    const resources = {
        sources: [
            {
                src: video,
                controls: true,
                preload: preload
            },
        ],
        poster: thumb
    };

    const handleVideoContextmenu = e => {
        e.preventDefault()
    }

    const dispatch = useDispatch();
    const videoDetails = video.split('/');
    const user = JSON.parse(localStorage.getItem('user'));
    const [showMark, setShowMark] = useState(true);

    useLayoutEffect(() => {
        let mounted = true;

        Array.prototype.random = function () {
            return this[Math.floor((Math.random()*this.length))];
        }

        const videoDom = document.querySelector('video');

        videoDom.addEventListener("contextmenu", (event) => {
            event.preventDefault();
        });

        return (() => {
            videoDom.removeEventListener("contextmenu", (event) => {
                event.preventDefault();
            });

            mounted = false;
        });
    }, []);

    const playerOptions = {
        src: video,
        controls: true,
        preload: preload,
        muted: muted,
        inactivityTimeout: 0,
    };

    const videojsOptions = {
        fluid: true,
        // nativeControlsForTouch: false,
        autoplay: autoplay,
    };

    const onVideoPlay = (event, player, currentTime) => {
        document.addEventListener('contextmenu', handleVideoContextmenu);
        dispatch(setVideoPlayerId(player.id_));
        dispatch(setVideoPlayerIsPlaying(true));
    }
    const onVideoEnd = () => {
        document.removeEventListener('contextmenu', handleVideoContextmenu);
        dispatch(setVideoPlayerId(null));
        dispatch(setVideoPlayerIsPlaying(false));
    }

    return <>
        { user.id !== parseInt(videoDetails[3]) && showMark && <div className={'video-thumbprint-container'}><Thumbprint /> </div>}
        <VREPlayer
            playerOptions={playerOptions}
            resources={resources}
            videojsOptions={videojsOptions}
            onContextMenu={e => e.preventDefault()}
            onPlay={ (event, player, currentTime) => onVideoPlay(event, player, currentTime) }
            onEnded={ onVideoEnd }
            onPause={ onVideoEnd }
            {...videoOptions}
        />
    </>;
};

const mapStateToProps = (state) => {
    return {
        isPlaying: state.videoPlayer.isPLaying,
    };
};

export default connect(mapStateToProps)(PVideo);
